export const navigation = {
  about: "About",
  activities: "Activity log",
  administration: "Administration",
  assets: "Assets",
  assetTypes: "Asset types",
  browse: "Browse by",
  collapse: "Collapse",
  dashboard: "Dashboard",
  events: "My events",
  expand: "Expand",
  import: "Import tool",
  interventions: "Interventions",
  interventionTemplates: "Intervention templates",
  language: "Language",
  locations: "Locations",
  logout: "Logout",
  mySpace: "My space",
  observations: "Observations",
  organizations: "Organizations",
  pageError: {
    notFound: {
      title: "The page you are looking for does not exist.",
      description: "It is possible that it has been moved, renamed or deleted.",
    },
    contextNotFound: {
      title: "Problem with the organization",
      description:
        "The organization you are trying to access does not exist, has been deleted, or you do not have access to it.",
    },
    default: {
      title: "An error has occurred",
      description:
        "Feel free to <HelpLink>contact support</HelpLink> if needed.",
    },
    returnToDashboard: "Go back to dashboard",
    returnToLogin: "Go back to login",
  },
  password: "Change password",
  preferences: "Preferences",
  projects: "Projects",
  support: "Support",
  technicalForms: "Technical forms",
  users: "Users",
};
